/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Duration_MinInputs */

const en_duration_min = /** @type {(inputs: Duration_MinInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} min`)
};

const he_duration_min = /** @type {(inputs: Duration_MinInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} דק׳`)
};

/**
* | output |
* | --- |
* | "{count} min" |
*
* @param {Duration_MinInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const duration_min = /** @type {((inputs: Duration_MinInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Duration_MinInputs, { locale?: "en" | "he" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_duration_min(inputs)
	return he_duration_min(inputs)
});